<template>
  <Head :title="__('vip-order-business-received.meta.title')">
    <meta
      name="description"
      :content="__('vip-order-business-received.meta.description')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="order-business-2">
    <div class="md:container">
      <Link :href="localeRoute('frontend.index')">
        <img
          src="/frontend/assets/logo.svg"
          class="mt-10 hidden lg:block mx-auto"
        >
      </Link>

      <div class="bg-white lg:mt-10 lg:rounded-2xl px-5 py-7 lg:px-20 lg:py-10 lg:mb-8 lg:w-4/5 lg:mx-auto">
        <div class="w-full">
          <div class="text-center border-b border-gray-100 pb-4 lg:w-1/2 lg:mx-auto">
            <h1 class="text-2xl font-bold">
              {{ __('vip-order-business-received.title') }}
            </h1>
          </div>
        </div>

        <div class="mt-24 text-center">
          <h2 class="block text-4xl font-bold lg:text-5xl md:px-24 lg:px-40">
            {{ __('vip-order-business-received.text') }}
          </h2>

          <h3 class="block mt-6 text-2xl font-bold">
            {{ __('vip-order-business-received.extra-text') }}
          </h3>
        </div>

        <div class="mt-8 w-full lg:text-center">
          <Link
            :href="localeRoute('frontend.index')"
            class="button-white-outline shadow-button-black w-full block lg:w-auto lg:inline-block lg:px-16"
          >
            {{ __('vip-order-business-received.continue') }}
          </Link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clean from '../../../Layout/Clean.vue';

export default {
  layout: Clean,
};
</script>
